import i18n from 'i18next';

const defaultErrorMessage = () => i18n.t('common.error', { defaultValue: 'Something went wrong' });

export const parseErrorMessage = (error) => {
  const responseMessage = error
    && error.response
    && error.response.data
    && error.response.data.message;

  if (responseMessage) {
    return responseMessage;
  }

  if (error && error.message && typeof error.message === 'string') {
    try {
      const normalized = error.message.replace(/'/g, '"');
      const parsed = JSON.parse(normalized);
      const keys = Object.keys(parsed);
      if (keys.length > 0 && Array.isArray(parsed[keys[0]]) && parsed[keys[0]].length > 0) {
        return parsed[keys[0]][0];
      }
    } catch (e) {
      return error.message;
    }
  }

  if (error && error.message) {
    return error.message;
  }

  return defaultErrorMessage();
};
